import React, { useRef, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Button, Card, Spinner } from "react-bootstrap";
import logoMain from "../../assets/icons/logo_main.svg";
import { usePasswordResetContext } from "../../contexts/PasswordResetContex";
import '../../styles/auth.css';

const OtpVerification = () => {

	const { email, setEmail, setOtp } = usePasswordResetContext();

	const [isSubmitting, setIsSubmitting] = useState(false);
	const [otpInput, setOtpInput] = useState({
		otp1: "",
		otp2: "",
		otp3: "",
		otp4: "",
		otp5: "",
		otp6: ""
	});

	const otp1Ref = useRef(null);
	const otp2Ref = useRef(null);
	const otp3Ref = useRef(null);
	const otp4Ref = useRef(null);
	const otp5Ref = useRef(null);
	const otp6Ref = useRef(null);

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>,
		ref: React.RefObject<HTMLInputElement> | null) => {
		const { name, value } = e.target;
		setOtpInput(prevState => ({ ...prevState, [name]: value }));

		if (value && ref && ref.current) {
			ref.current.focus();
		}
	};

	const navigate = useNavigate();

	const handleOtpSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setIsSubmitting(true);

		const otp = Object.values(otpInput).join('');
		setEmail(email);
		setOtp(otp);

		navigate('/auth/reset-password', { state: { otp, email } })
		setIsSubmitting(false);
	};

	const isOtpComplete = Object.values(otpInput).every(value => value.trim() !== '');

	return (
		<>
			<div className="body-bg-blue">
				<div className="auth-body">
					<div className="auth-img-white mb-5">
						<img src={logoMain} alt="logo" />
						<h2>Scholarswitch</h2>
					</div>
					<Card>
						<Card.Body>
							<div className="mb-4">
								<h3>Login To Your Portal</h3>
								<p>Enter the OTP sent to your email address</p>
							</div>
							<div className="user-email">email</div>

							<form onSubmit={handleOtpSubmit}>
								<div className="otp-input-section">
									<div className="otp-input">
										<input
											aria-label="otp1"
											name="otp1"
											value={otpInput.otp1}
											onChange={(e) => handleInputChange(e, otp2Ref)}
											maxLength={1}
											ref={otp1Ref}
										/>
										<input
											aria-label="otp2"
											name="otp2"
											value={otpInput.otp2}
											onChange={(e) => handleInputChange(e, otp3Ref)}
											maxLength={1}
											ref={otp2Ref}
										/>
										<input
											aria-label="otp3"
											name="otp3"
											value={otpInput.otp3}
											onChange={(e) => handleInputChange(e, otp4Ref)}
											maxLength={1}
											ref={otp3Ref}
										/>
										<div>-</div>
										<input
											aria-label="otp4"
											name="otp4"
											value={otpInput.otp4}
											onChange={(e) => handleInputChange(e, otp5Ref)}
											maxLength={1}
											ref={otp4Ref}
										/>
										<input
											aria-label="otp5"
											name="otp5"
											value={otpInput.otp5}
											onChange={(e) => handleInputChange(e, otp6Ref)}
											maxLength={1}
											ref={otp5Ref}
										/>
										<input
											aria-label="otp6"
											name="otp6"
											value={otpInput.otp6}
											onChange={(e) => handleInputChange(e, null)}
											maxLength={1}
											ref={otp6Ref}
										/>
									</div>
									<div className="auth-flex">
										<span style={{ color: '#116DFF' }}>Resend OTP</span>
										<span>0:23 secs</span>
									</div>
								</div>

								<Button
									type="submit"
									disabled={isSubmitting || !isOtpComplete}
									className={!isOtpComplete || isSubmitting ? 'disabled-button' : ''}
								>
									{isSubmitting ? <Spinner animation="border" size="sm" /> : "Confirm Code"}
								</Button>
							</form>
							<Link to={'/'}>Back to login</Link>
						</Card.Body>
					</Card>
				</div>
			</div>
		</>
	)
};

export default OtpVerification;